import React from "react"
import { motion } from "framer-motion"

export const popVariants = {
  hidden: {
    opacity: 0,
    scale: 0.95,
    height: 0,
    marginTop: 0,
    marginBottom: 0,
    transition: {
      opacity: { duration: 0.15 },
    },
  },
  visible: {
    opacity: 1,
    scale: 1,
    height: "auto",
    transition: {
      type: "spring",
      stiffness: 420,
      damping: 32,
    },
  },
}

const AnimatedList = ({
  children,
  isVisible,
  index,
  delayFromIndex = 0,
  variants = popVariants,
  disableLayout = false,
}) => {
  return (
    <motion.div
      layout={!disableLayout}
      variants={variants}
      initial={false}
      animate={isVisible ? "visible" : "hidden"}
      transition={{
        delay: isVisible && delayFromIndex ? index * delayFromIndex : 0,
      }}
      style={{ overflow: "hidden" }}
    >
      {children}
    </motion.div>
  )
}

export default AnimatedList
